export default "__VITE_PUBLIC_ASSET__8932dc2e__"